import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import {Fade} from "../../components/FadeReveal/FadeReveal";
import "./WhatIDeliver.scss";
import StyleContext from "../../contexts/StyleContext";
import {whatIDeliver} from "../../portfolio";

export default function WhatIDeliver() {
  const {isDark} = useContext(StyleContext);
  const {t} = useTranslation();

  if (!whatIDeliver.display) {
    return null;
  }

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className={isDark ? "dark-mode main" : "main"} id="what-i-deliver">
        <div className="wid-header">
          <h1 className={isDark ? "dark-mode wid-title" : "wid-title"}>
            {t("whatIDeliver.title")}
          </h1>
          <p className={isDark ? "dark-mode wid-subtitle" : "wid-subtitle"}>
            {t("whatIDeliver.subtitle")}
          </p>
        </div>
        <div className="wid-cards-grid">
          {whatIDeliver.items.map((item, i) => (
            <Fade bottom duration={1000} distance="20px" key={i}>
              <div className={`wid-card ${isDark ? "dark-mode" : ""}`}>
                <div className="wid-card-icon-wrap">
                  <span className="wid-card-icon">{item.icon}</span>
                </div>
                <h3 className={isDark ? "dark-mode wid-card-title" : "wid-card-title"}>
                  {t(item.titleKey)}
                </h3>
                <p className={isDark ? "dark-mode wid-card-desc" : "wid-card-desc"}>
                  {t(item.descKey)}
                </p>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </Fade>
  );
}
